import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { CssBaseline } from "@mui/material";
import { UserProvider } from "./shared/context/UserContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <UserProvider>
    <CssBaseline />
    <App />
  </UserProvider>
);

reportWebVitals();